import { Component, DestroyRef, EventEmitter, Output, inject } from "@angular/core";
import { CoreCommonModule } from "@core/common.module";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AuthenticationService } from "@core/services/auth";

@Component({
  standalone: true,
  imports: [CoreCommonModule],
  selector: "app-teacher-forgot-username",
  templateUrl: "./teacher-forgot-username.html",
  styleUrls: ["./teacher-forgot-username.scss"],
})
export class TeacherForgotUsernameComponent {
  @Output() back = new EventEmitter<void>();

  teacherForgotUsernameForm: UntypedFormGroup;
  loading = false;
  teacherForgotUsernameError = "";
  teacherForgotUsernameSuccess = "";

  private destroyRef = inject(DestroyRef);
  private _formBuilder = inject(UntypedFormBuilder);
  private _authenticationService = inject(AuthenticationService);

  constructor() {
    this.teacherForgotUsernameForm = this._formBuilder.group({
      phone: ["", [Validators.required, Validators.pattern(/^0\d{9}$/)]],
    });
  }

  onSubmit(): void {
    if (this.teacherForgotUsernameForm.invalid) return;

    this.teacherForgotUsernameError = "";
    this.teacherForgotUsernameSuccess = "";
    this.loading = true;

    const phone = this.teacherForgotUsernameForm.get("phone").value;

    this._authenticationService
      .getUsernameFromPhone(phone)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.teacherForgotUsernameSuccess =
            "We will send you an sms to this phone number to help you remember your username.";
          this.loading = false;
        },
        error: (err) => {
          this.teacherForgotUsernameError = err.error?.message || "An error occurred";
          this.loading = false;
        },
      });
  }

  onBack(): void {
    this.back.emit();
  }
}